import { MutationTuple, useMutation } from '@apollo/client';

import {
  DeleteAscProjectMutation,
  DeleteAscProjectMutationVariables,
  DELETE_ASC_PROJECT,
  evictCache,
  GetAscProjectsQueryVariables,
  GET_ASC_PROJECTS,
} from '@neo.tax/shared';

import { useAscContext } from '../context';

type UseDeleteAscProjectProps = {
  companyId: string;
  ascProjectId: string;
};

export const useDeleteAscProject = ({
  ascProjectId,
  companyId,
}: UseDeleteAscProjectProps): MutationTuple<DeleteAscProjectMutation, DeleteAscProjectMutationVariables> => {
  const { fiscalYearId, periodName } = useAscContext();
  return useMutation<DeleteAscProjectMutation, DeleteAscProjectMutationVariables>(DELETE_ASC_PROJECT, {
    context: {
      successToast: {
        title: 'Project deleted successfully',
      },
    },
    variables: { ascProjectId },
    refetchQueries: [
      {
        query: GET_ASC_PROJECTS,
        variables: { companyId, fiscalYearId, periodName } satisfies GetAscProjectsQueryVariables,
      },
    ],
    awaitRefetchQueries: true,
    update: (cache) => {
      evictCache(cache, ['getAscProjectTeamMembers', 'getAscProjectTpTickets']);
    },
  });
};
